import { ChangeEvent, useEffect, useState } from "react";
import useFirestore from "shared/hooks/useFirestore";
import { v4 as uuidv4 } from "uuid";
import useGetBranchId from "shared/hooks/useGetBranchId";

const useCounselRegister = (student_uid:string) => {
    const {getBranchId} = useGetBranchId();
    const { readFirestoreOneDoc, addFireStore } = useFirestore();
    const [isOpenNullModal, setIsOpenNullModal] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isSucceed, setIsSucced] = useState(false);
    const [student, setStudent] = useState<string>("");
    const [inputs, setInputs] = useState({
        counsel_detail:"",
        action_detail:"",
        counsel_date:""
    })

    useEffect(() => {
        if(student_uid){
            getStudentName();
        }
        // eslint-disable-next-line
    }, [student_uid])

    const onChange = (e:ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const {name, value} = e.target;

        setInputs({
            ...inputs,
            [name]:value
        })
    }

    const getStudentName = async() => {
        const name = await readFirestoreOneDoc("User/Auth/Student", student_uid).then(res => {
            if(res.exists()){
                return res.data().name;
            }
        })

        setStudent(name);
    }

    const onSaveClick = () => {
        register();
    }

    const register = async() => {
        const branch_id = await getBranchId();
        if(!(inputs.counsel_date && inputs.counsel_detail)){
            setIsOpenNullModal(true);
            return;
        }

        const data = {
            ...inputs,
        }
        
        addFireStore(`Counsel/${branch_id}/${student_uid}`, data).then(res => {
            if(res){
                setIsSucced(true);
            }else{
                setIsError(true);
            }
        })
        
    }

    return {student, onChange, inputs, onSaveClick, isSucceed, isError, isOpenNullModal, setIsOpenNullModal, setIsError};
}

export default useCounselRegister;